<!--
* @Name：供应商付款付款信息
* @Author: 刘玉
* @Date: 2021-12-02 15:43:41
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 15:43:41
-->
<template>
  <div>
    <hi-card v-for="(item, index) in paymentDetails" :key="item.pk" :row-index="index + 1">
      <van-row>
        <span>供应商：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row>
        <span>实际申请付款金额：</span>
        <span>{{ item.actualPayAmount }}</span>
      </van-row>
      <van-row>
        <span>电汇金额：</span>
        <span>{{ item.ttAmount }}</span>
      </van-row>
      <van-row>
        <span>票据金额：</span>
        <span>{{ item.billAmount }}</span>
      </van-row>
      <van-row>
        <span>核销方式：</span>
        <span>{{ item.verifyWay | dictFilter(verifyWayOptions) }}</span>
      </van-row>
      <van-row>
        <span>付款类型：</span>
        <span>{{ item.payType | dictFilter(payMouldOptions) }}</span>
      </van-row>
      <van-row>
        <van-button
          v-if="paymentTypeCode === '01' || paymentTypeCode === '02' || paymentTypeCode === '03'"
          type="info"
          size="mini"
          @click="viewDetails(item)"
          >查看明细</van-button
        >
        <van-button v-if="item.billAmount" type="info" size="mini" @click="viewOrder(item)">查看票据</van-button>
      </van-row>
    </hi-card>
    <view-details v-if="viewDetailsVisible" @close="viewDetailsVisible = false" :details-data="detailsData" />
    <view-order v-if="viewOrderVisible" @close="viewOrderVisible = false" :order-info="orderInfo" />
  </div>
</template>

<script>
export default {
  name: 'PaymentDetails',
  components: {
    'view-details': () => import('./ViewDetails.vue'),
    'view-order': () => import('./ViewOrder.vue')
  },
  data() {
    return {
      detailsData: [],
      orderInfo: [],
      viewDetailsVisible: false,
      viewOrderVisible: false,
      payStatusVisible: false
    }
  },
  props: {
    // 付款类型：
    // 01: 货到付款/款到发货/预付款
    // 02: 货到付款/票到付款提前付款
    // 03: 月结
    // 04: 月结提前付款
    // 05: 票到付款
    paymentTypeCode: {
      type: String
    },
    paymentDetails: {
      type: Array,
      default: () => []
    },
    orderInfoList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    verifyWayOptions() {
      return this.$store.getters.dicts.verify_way
    },
    payMouldOptions() {
      return this.$store.getters.dicts.pay_mould
    }
  },
  methods: {
    viewDetails(item) {
      this.detailsData = item.coopPoHeadDtos
      this.viewDetailsVisible = true
    },
    viewOrder(item) {
      this.orderInfo = this.orderInfoList.filter(
        el => el.companyCode === item.companyCode && el.supplierCode === item.supplierCode
      )
      this.viewOrderVisible = true
    },
    payStatus() {
      this.payStatusVisible = true
    }
  }
}
</script>
